import React from 'react'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import { CTA } from 'common/styleguide/CTA'
import { centeredText } from 'lib/styleguide/base.scss'
import img from './img.png'
import { getCurrentUser } from 'lib/utils'

export const PRINT_UPSELL_MODAL = 'PRINT_UPSELL_MODAL'

export const PrintUpsellModal = ({ troute, objectType, onRequestClose }) => {
  const trial = getCurrentUser().eligibleForOnetimeTrial
  return (
    <ModalOverlay
      maxWidth='900px'
      onRequestClose={onRequestClose}>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: '1 1 50%', position: 'relative' }}>
          <img src={img} alt='print cuesheet' style={{ maxWidth: '90%' }} />
        </div>
        <div style={{ flex: '1 1 50%', display: 'flex', alignItems: 'center' }}>
          <div>
            <h2>PDF Maps & Cuesheets</h2>
            <p>
              Craft the perfect map with multiple size and orientation options, ordered
              points of interest, custom cues, and multiple map styles to choose from.
            </p>
            <CTA href={`/subscriptions/new?account_level=premium${trial ? '&trial=1' : ''}`}>
              {trial ? 'Start Free Trial' : 'Upgrade Now'}
            </CTA>
            {objectType === 'route' && <p className={centeredText}>
              <a href={`/routes/${troute.id}/cue_sheet`} target='_blank'>No thanks, just take me to the basic cuesheet print page</a>
            </p>}
            {objectType === 'trip' && <p className={centeredText}>
              <a href={`/trips/${troute.id}/printmap`} target='_blank'>No thanks, just take me to the basic map print page</a>
            </p>}
          </div>
        </div>
      </div>
    </ModalOverlay>
  )
}
